/**
 * impersonationStrings.js — shared copy for "X is disabled while
 * impersonating" surfaces.
 *
 * Adding a new hard-disable surface? Append the literal here and grep
 * for the old copy + replace at the call site. Keeping these in one
 * module means Jest regression tests can assert the rendered tooltip
 * matches verbatim without each surface defining its own private
 * constant.
 *
 * Phase 3.3 G1 — refund control hard-disable.
 */

// Phase 3.3 G1 — refund control hard-disable copy.
// Locked verbatim by dispatch. Surfaced on the admin BookingDetailModal
// refund button (Tooltip) AND mirrored as the backend 403 message body
// at `backend/admin_refunds.py::_REFUND_DISABLED_TOOLTIP`. The two must
// agree byte-for-byte so the test that grepss the rendered DOM also
// proves the server-side error stays in sync.
export const REFUND_DISABLED_WHILE_IMPERSONATING =
  "Refunds are disabled while impersonating. Exit impersonation to proceed.";

// Existing BookingWizard surface — Phase 2 era. Re-exported here as
// part of the gradual migration from per-component local constants.
// BookingWizard.jsx still defines its own copy at module-local scope;
// future cleanup pass can swap it to import from here.
export const BOOKING_PAYMENT_DISABLED_WHILE_IMPERSONATING =
  "Booking/payment unavailable while impersonating";
